import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function _4mpIcon(props: IconProps) {
    return <Icon {...props} iconKey={"4mp"}/>
}
